import React, { useState, useEffect } from 'react';
import SettingsHeader from './console/SettingsHeader';
import { Form } from 'react-bootstrap';
import axios from 'axios';
import ConsoleNavMenu from './console/ConsoleNavMenu';

const AdminSubscription = () => {
  const queryParams = new URLSearchParams(window.location.search)
  const [subscriptions, setSubscriptions] = useState<Array<AstraSubscription>>([]);
  const [createCodeEmail, setCreateCodeEmail] = useState<string>("");
  const [subscriptionCount, setSubscriptionCount] = useState<SubscriptionCount>();
  const [prolongationDays, setProlongationDays] = useState<number>(20);
  const [generateDaysFile, setGenerateDaysFile] = useState(31);
  const [generateCountFile, setGenerateCountFile] = useState(50);
  
  useEffect(() => {
    axios.get<Array<AstraSubscription>>('api/astraAdminSubscription/getByTimeCreate?count=50&page=0')
      .then(response => {
          console.log(response.data);
          setSubscriptions(response.data);
      }
    );

    axios.get<SubscriptionCount>('api/astraAdminSubscription/getSubscriptionCount')
      .then(response => {
        setSubscriptionCount(response.data);
      }
    );
  }, []);

  function createCode() {
    axios.get<Array<AstraSubscription>>('api/astraAdminSubscription/createCode?email=' + createCodeEmail)
      .then(response => {
          window.location.reload();
      }
    );
  }

  function prolongation() {
    axios.get(`api/astraAdminSubscription/prolongationAll?days=` + prolongationDays);
  }

  function downloadLog(dayCount: number, codeCount: number){
    var imei = queryParams.get("imei")
    axios({
      url: 'api/astraAdminSubscription/downloadCodes?dayCount=' + dayCount + "&codeCount=" + codeCount,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "activation_keys.csv");
      document.body.appendChild(link);
      link.click();
    });
  }
  
  return (
          <>
            <ConsoleNavMenu />
            <div className='blocks'>
              <div className='body-box'>
                <p>Subscription count: {subscriptionCount?.all} Active: {subscriptionCount?.active}</p>
                <table className='table table-striped' aria-labelledby="tabelLabel" style={{tableLayout: "fixed"}}>
                  <thead>
                    <tr>
                      <th style={{width: "30%"}}>Email</th>
                      <th style={{width: "20%"}}></th>
                      <th style={{width: "10%"}}></th>
                      <th style={{width: "30%"}}></th>
                      <th style={{width: "30%"}}></th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr key="key">
                        <td><Form.Control type="email" defaultValue={createCodeEmail} onChange={(event) => {setCreateCodeEmail(event.target.value)}} /></td>
                        <td></td>
                        <td style={{fontSize: "15px"}}></td>
                        <td></td>
                        <td><button style={{width: "100%"}} className="btn btn-danger" onClick={() => {createCode();}}>Create code</button></td>
                      </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th style={{width: "30%"}}>-</th>
                      <th style={{width: "20%"}}></th>
                      <th style={{width: "10%"}}></th>
                      <th style={{width: "30%"}}></th>
                      <th style={{width: "30%"}}></th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr key="key">
                        <td>Продлить на это кол-во дней:</td>
                        <td><Form.Control type="number" defaultValue={prolongationDays} onChange={(event) => {setProlongationDays(parseInt(event.target.value))}} /></td>
                        <td style={{fontSize: "15px"}}></td>
                        <td>Продлится только тем у кого меньше дней!</td>
                        <td><button style={{width: "100%"}} className="btn btn-danger" onClick={() => {prolongation();}}>Prolongation</button></td>
                      </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th style={{width: "30%"}}>-</th>
                      <th style={{width: "20%"}}></th>
                      <th style={{width: "10%"}}></th>
                      <th style={{width: "30%"}}></th>
                      <th style={{width: "30%"}}></th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th style={{width: "30%"}}>Количество дней</th>
                      <th style={{width: "20%"}}>Количество подписок</th>
                      <th style={{width: "10%"}}></th>
                      <th style={{width: "30%"}}></th>
                      <th style={{width: "30%"}}></th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr key="key">
                        <td><Form.Control type="number" defaultValue={generateDaysFile} onChange={(event) => {setGenerateDaysFile(parseInt(event.target.value))}} /></td>
                        <td><Form.Control type="number" defaultValue={generateCountFile} onChange={(event) => {setGenerateCountFile(parseInt(event.target.value))}} /></td>
                        <td style={{fontSize: "15px"}}></td>
                        <td></td>
                        <td><button style={{width: "100%"}} className="btn btn-danger" onClick={() => {downloadLog(generateDaysFile, generateCountFile);}}>Generate File</button></td>
                      </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th style={{width: "30%"}}>Email</th>
                      <th style={{width: "20%"}}>Code</th>
                      <th style={{width: "10%"}}>Is active</th>
                      <th style={{width: "30%"}}>Time create</th>
                      <th style={{width: "30%"}}>Time deactivation</th>
                    </tr>
                  </thead>
                  <tbody>
                  {subscriptions.map(i =>
                      <tr key={i.modemId}>
                        <td>{i.email}</td>
                        <td>{i.code}</td>
                        <td>{i.isActive ? "Active" : ""}</td>
                        <td>{i.timeCreate}</td>
                        { i.isRotten ? <td style={{color: "red"}}>{i.timeDeactivation}</td> : <td>{i.timeDeactivation}</td>}
                        {/*<td><Link to={`/statistics/modem?imei=${i.imei}`}>{i.imei}</Link></td>*/}
                      </tr>
                  )}
                  </tbody>
                </table> 
              </div>
            </div>
          </>
  );
};

export default AdminSubscription;